import { createFileRoute } from "@tanstack/react-router";
import Ambarcatiuni from "@/pages/Ambarcatiuni";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/uk/boats/")({
  head: () => routeHead("/uk/boats/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Ambarcatiuni />
  );
}
